import React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import ReactSVG from 'react-svg';
import uptodate from '../../img/up-to-date.svg';

const EmptyScreen = ({ t, notYetTheTime, daysToShowingSection }) => (
  <div className="u-text-center">
    <h3>
      {notYetTheTime
        ? t('manageUpdates.confirmNotYetTheTime.title', {
            count: daysToShowingSection,
            postProcess: 'interval',
          })
        : t('manageUpdates.confirmSuccess.title')}
    </h3>
    <p className="u-weight-light">
      {notYetTheTime
        ? t('manageUpdates.confirmNotYetTheTime.note')
        : t('manageUpdates.confirmSuccess.note')}
    </p>

    <Link to="/my-profile" className="c-btn c-btn-outline">
      {t('general.goProfile')}
    </Link>
    <ReactSVG
      src={uptodate}
      svgClassName="u-margin-vertical-huge u-img-responsive"
    />
  </div>
);

export default translate()(EmptyScreen);



// WEBPACK FOOTER //
// ./src/updates/user-confirm/EmptyScreen.js